module.exports = __webpack_public_path__ + "img/2.1c128710.png";